
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import QRCode from "qrcodejs2";

@Component({})
export default class QrCode extends Vue {
  @Prop({ type: Number, default: 150 })
  width: string;
  @Prop({ type: Number, default: 150 })
  height: string;
  @Prop({ type: Number, default: 10 })
  padding: string;
  @Prop({ type: String })
  url: string;
  generate() {
    const qrDom = this.$refs["qrcode"];
    (qrDom as any).innerHTML = "";
    let qrcode = new QRCode(qrDom, {
      width: this.width, //图像宽度
      height: this.height, //图像高度
      colorDark: "#000000", //前景色
      colorLight: "#ffffff", //背景色
      typeNumber: 4,
      correctLevel: QRCode.CorrectLevel.H //容错级别 容错级别有：（1）QRCode.CorrectLevel.L （2）QRCode.CorrectLevel.M （3）QRCode.CorrectLevel.Q （4）QRCode.CorrectLevel.H
    });
    qrcode.clear(); //清除二维码
    qrcode.makeCode(this.url); //生成另一个新的二维码
  }
  getQrBase64() {
    const imgDom = (this.$refs["qrcode"] as any).getElementsByTagName("img");
    return imgDom[0].src;
  }
  @Watch("url")
  urlChange(val, oldValue) {
    if (val && val !== oldValue) {
      this.generate();
    }
  }
}
